import React from 'react';
import { useTheme } from '../../hooks/useTheme';
import LayoutComponent from './LayoutComponent';

const Footer = ({ 
  statusItems = [],
  isDarkMode = false,
  className = "",
  ...props 
}) => {
  const currentTheme = useTheme(isDarkMode);
  // Estilos personalizados específicos del Footer (además de los estilos base)
  const footerCustomStyles = {
    ...props.style
  };

  const statusItemStyles = {
    display: 'flex',
    alignItems: 'center',
    gap: currentTheme.spacing.sm,
    marginRight: currentTheme.spacing.lg,
    padding: `${currentTheme.spacing.xs} ${currentTheme.spacing.sm}`,
    borderRadius: currentTheme.borderRadius.sm,
    transition: 'background-color 0.2s ease-in-out',
    cursor: 'pointer'
  };

  const statusIndicatorStyles = {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    backgroundColor: currentTheme.colors.interactive.success
  };

  const statusTextStyles = {
    fontSize: currentTheme.typography.fontSize.xs,
    color: currentTheme.colors.text.secondary,
    fontFamily: currentTheme.typography.fontFamily.mono
  };

  const progressBarStyles = {
    width: '120px',
    height: '4px',
    backgroundColor: currentTheme.colors.border.primary,
    borderRadius: '2px',
    overflow: 'hidden',
    marginLeft: currentTheme.spacing.sm
  };

  const progressFillStyles = {
    height: '100%',
    backgroundColor: currentTheme.colors.interactive.primary,
    transition: 'width 0.3s ease-in-out'
  };

  const handleStatusItemHover = (e) => {
    // Hover effect disabled - no color changes on mouse over
    return;
  };

  const handleStatusItemLeave = (e) => {
    // Hover effect disabled - no color changes on mouse leave
    return;
  };

  const defaultStatusItems = [
    {
      key: 'tokenizer',
      label: 'Tokenizer',
      status: 'Off',
      color: currentTheme.colors.interactive.secondary,
      onClick: () => console.log('Tokenizer clicked')
    },
    {
      key: 'context',
      label: 'Context',
      value: '0/200k (0%)',
      showProgress: true,
      progress: 0,
      onClick: () => console.log('Context clicked')
    }
  ];

  const items = Array.isArray(statusItems) ? statusItems : [];

  return (
    <LayoutComponent 
      componentType="footer" 
      isDarkMode={isDarkMode}
      className={className}
      customStyles={footerCustomStyles}
    >
      {items.map((item, index) => (
        <div
          key={item.key || index}
          style={statusItemStyles}
          onMouseEnter={handleStatusItemHover}
          onMouseLeave={handleStatusItemLeave}
          onClick={item.onClick}
          title={item.tooltip}
        >
          {/* Status Indicator */}
          {item.status && (
            <div style={{
              ...statusIndicatorStyles,
              backgroundColor: item.color || currentTheme.colors.interactive.success
            }} />
          )}

          {/* Label */}
          <span style={statusTextStyles}>
            {item.label}:
          </span>

          {/* Value or Status */}
          <span style={statusTextStyles}>
            {item.value || item.status}
          </span>

          {/* Progress Bar */}
          {item.showProgress && (
            <div style={progressBarStyles}>
              <div style={{
                ...progressFillStyles,
                width: `${item.progress || 0}%`
              }} />
            </div>
          )}
        </div>
      ))}
    </LayoutComponent>
  );
};

export default Footer;
